import { jsx as _jsx } from "react/jsx-runtime";
import './HelpPopup.css';
import Popup from './Popup';
import { helpIcon } from '../icons/helpIcon';
const HelpPopup = (props) => {
    var _a;
    return _jsx(Popup, { topRightIcon: helpIcon, ...props, className: `helpPopup ${(_a = props.className) !== null && _a !== void 0 ? _a : ''}`, children: props.children });
};
export default HelpPopup;
